import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import useLocationSelector from '@components/LocationSelector/useLocationSelector';
// Create the context with a default value
const LocationContext = createContext(undefined);
// Create a provider component
export const LocationProvider = ({ children }) => {
    const locationSelector = useLocationSelector();
    return (_jsx(LocationContext.Provider, { value: locationSelector, children: children }));
};
// Custom hook to use the LocationContext
export const useLocationContext = () => {
    const context = useContext(LocationContext);
    if (!context) {
        throw new Error('useLocationContext must be used within a LocationProvider');
    }
    return context;
};
